export enum SchemaType {
    AwsSecurityGroup = 'AwsSecurityGroup',
    NetworkSecurityGroup = 'NetworkSecurityGroup',
}
